module.exports = __webpack_public_path__ + "img/8de6562.png";